import { Injectable, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {APP_SETTINGS, DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MobileNavigationService {
    private currentIndex: number = 0;
    private maxIndex:number = 0;
    public get windowWidth(): number{
        if(!this.isServer)
        {
            return window.innerWidth;
        }
        
        return 500;
    };
    public indexSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    public navigationSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public orientationSubject: Subject<void> = new Subject<void>();
    private isServer:boolean = false;
    public clientObjects: Object = {};
    private isPhone:boolean = false;

    constructor (
    @Inject(PLATFORM_ID) platformId: string,
    @Inject(APP_SETTINGS) private settings: Object,
    @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo
    ){
        this.isServer = isPlatformServer(platformId); 
        this.isPhone = deviceInfo.isPhone;
        
        if(!this.isServer)
        {
            window.addEventListener("orientationchange", event => {
                this.orientationSubject.next();
            });
        }
        
    }

    public registerClientObject(index:number, object:ElementRef){
        this.clientObjects[index] = object;
        
        if(index > this.maxIndex)
            this.maxIndex = index;
    }

    public setData(data:any){
        this.navigationSubject.next(data);
    }

    public clear(){
        this.clientObjects = {};
        this.index = 0;
        this.maxIndex = 0;
    }

    public set index(indexValue: number){
        this.currentIndex = indexValue;
        this.indexSubject.next(this.currentIndex);

        if(!this.isServer && this.isPhone)
        {
            window.scrollTo(0,0);
        }
    }

    public incrementIndex(){
        if(this.currentIndex < this.maxIndex)
            this.index = this.currentIndex+1;
    }

    public decrementIndex(){
        if(this.currentIndex > 0)
            this.index = this.currentIndex-1;
    }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service.ts